import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link, useParams, useHistory, useRouteMatch } from "react-router-dom"
import { selectUid } from "../../stores/appSlice"
// import { fetchDivisions, searchDivisions, selectDivisions, selectDivisionSearch, selectTotal } from "../divisions/divisionsSlice"
import PaginatedSelect from "../forms/components/PaginatedSelect"
import { debounce } from "lodash"
import nodePath from "path"
import { DownloadOutlined, EyeInvisibleOutlined, EyeOutlined, FileAddOutlined, LeftOutlined } from "@ant-design/icons"
import { Button, Col, notification, Row, Select, Upload, Switch } from "antd"
import { clearPreview, getAssociations, getPreview, getTemplate, processImport, selectBillableAccounts, selectDivisions, selectFacilities, selectLedgerAccounts, selectLedgerFields, selectLoading, selectMeterNumbers, selectPreviewValues, selectSupplyAccounts, selectUtilityServices, selectVendors } from "./bulkEditSlice"
import LedgerAccountPreviewTable from "./components/LedgerAccountPreviewTable"
import FiltersForm from "./components/FiltersForm"
import DivisionPreviewTable from "./components/DivisionPreviewTable"
import FacilityPreviewTable from "./components/FacilityPreviewTable"
import BillableAccountPreviewTable from "./components/BillableAccountPreviewTable"
import VendorPreviewTable from "./components/VendorPreviewTable"
import UserPreviewTable from "./components/UserPreviewTable"
import ServicePreviewTable from "./components/ServicePreviewTable"
import { selectUserRolesForUser } from "../userRoles/userRolesSlice"

export default function BulkEditForm({ dataType }) {
    const { url } = useRouteMatch()
    const history = useHistory()
    const { clientId } = useParams()
    const dispatch = useDispatch()

    const uid = useSelector(selectUid)

    /* Filtering Vars */
    // const divisions = useSelector(selectDivisions)
    // const vendors = useSelector(selectVendors)
    // const supplyAccounts = useSelector(selectSupplyAccounts)
    // const billableAccounts = useSelector(selectBillableAccounts)
    // const meterNumbers = useSelector(selectMeterNumbers)
    // const facilities = useSelector(selectFacilities)
    // const ledgerAccounts = useSelector(selectLedgerAccounts)
    // const ledgerFields = useSelector(selectLedgerFields)
    // const utilityServices = useSelector(selectUtilityServices)
    /* End Filtering Vars */

    const preview = useSelector(selectPreviewValues)
    const loading = useSelector(selectLoading)
    const userRoles = useSelector(selectUserRolesForUser)

    const [file, setFile] = useState(null)
    const [formattedDataType, setFormattedDataType] = useState(getFormattedDataType())
    const [blankExport, setBlankExport] = useState(true)
    const [showPreview, setShowPreview] = useState(false)
    const [useFilters, setUseFilters] = useState(false)

    // useEffect(() => {
    //     fetchAssociations()
    // }, [dispatch])

    useEffect(()=>{
        if(userRoles === null) history.goBack()
    },[url])

    // Preview rows live in redux and are only fetched when empty, so another type's rows would show here.
    useEffect(() => {
        dispatch(clearPreview())
    }, [dataType])

    const openNotification = () => {
        notification.open({
            message: "Starting Bulk Edit Process",
            description: `Starting ${dataType} bulk editing process.`,
            duration: 2,
        })
    }

    const fileSelect = (file) => {
        setFile(file)
        return false
    }

    const fileRemove = () => {
        setFile(null)
    }

    // function getFields(){
    //     switch (dataType){
    //         case 'billableAccount':
    //             return ['facility', 'facility_type', 'division_name', 'name', 'vendor', 'account_number', 'meter_number', 'services', 'tax_id']
    //         default:
    //             return []
    //     }
    // }

    const fetchAssociations = () => {
        dispatch(getAssociations(clientId, dataType))
    }

    function pluralize(word) {
        if (word.endsWith("y")) return word.slice(0, -1) + "ies"
        if (word.endsWith("s")) return word + "es"
        return word + "s"
    }

    function getFormattedDataType() {
        const formatted = dataType
            .replace(/([A-Z])/g, " $1")
            .trim()
            .replace(/\b\w/g, (l) => l.toUpperCase())

        return pluralize(formatted)
    }

    const getPreviewTable = () => {
        switch (dataType) {
            case "ledgerAccount":
                return <LedgerAccountPreviewTable data={preview} blank={blankExport} />
            case "division":
                return <DivisionPreviewTable data={preview} blank={blankExport} />
            case 'facility':
                return <FacilityPreviewTable data={preview} blank={blankExport} />
            case 'billableAccount':
                return <BillableAccountPreviewTable data={preview} blank={blankExport} />
            case 'vendor':
                return <VendorPreviewTable data={preview} blank={blankExport} />
            case 'user':
                return <UserPreviewTable data={preview} blank={blankExport} />
            case 'service':
                return <ServicePreviewTable data={preview} blank={blankExport} />
            default:
                return false
        }
    }

    // const handleSearch = debounce((value) => {
    //     if (value && value.length >= 3) {
    //         dispatch(searchDivisions(value))
    //     }
    // }, 1000)

    return (
        <div id="user-form-container">
            <Link to={nodePath.join(url, "../").replace(/\/$/, "")}>
                <LeftOutlined />
                Go Back
            </Link>

            <div className="card">
                <div className="card-body">
                    <div>
                        <Row gutter={24}>
                            <Col span={24}>
                                <h3>{formattedDataType} Bulk Edit</h3>
                                <p>Edit multiple {formattedDataType} at once with a genertaed CSV template.</p>
                                {/* <p>
                                    <b>
                                        The required format of the file data is VERY specific. It is HIGHLY recommended you download the template file below to ensure your data is properly imported.
                                    </b>
                                </p>
                                <p>Import could potentially be successful with incorrect data. Please make sure to check all the bills created for any issues.</p> */}
                                <p>
                                    Each file, by default, contains all the possible editable values. Every column is optional{" "}
                                    <b>
                                        <u>EXCEPT COLUMN A</u>
                                    </b>
                                    .
                                </p>

                                <p>You may choose to either leave all the columns, or only have the ones needed to edit the specific value(s).</p>
                                <p>
                                    The file can be generated blank {" "}
                                    {/* (containing no information of the {formattedDataType})  */}
                                    OR with all its current values.
                                </p>
                                {dataType === "service" && (
                                    <p>Account Number, Vendor, Facility and Utility Service are for reference and are not changed by the import. Blank cells leave the current value unchanged.</p>
                                )}

                                <br />
                                <br />

                                <div style={{ display: "flex", gap: "10px" }}>
                                    Create a blank CSV (only contains necessary value)
                                    <Switch onChange={() => setBlankExport(!blankExport)} checked={blankExport} />
                                </div>

                                {/* <br />

                                <div style={{ display: "flex", gap: "10px" }}>
                                    Use Filters
                                    <Switch onChange={() => setUseFilters(!useFilters)} checked={useFilters} />
                                </div>

                                <br />

                                {useFilters && (
                                    <FiltersForm
                                        options={{
                                            divisions: divisions,
                                            vendors: vendors,
                                            supplyAccounts: supplyAccounts,
                                            billableAccounts: billableAccounts,
                                            facilities: facilities,
                                            ledgerAccounts: ledgerAccounts,
                                            ledgerFields: ledgerFields,
                                            utilityServices: utilityServices,
                                        }}
                                        loading={loading}
                                    />
                                )} */}

                                <br />

                                <div style={{ display: "flex", gap: "10px" }}>
                                    <Button
                                        disabled={loading}
                                        icon={!showPreview ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                                        onClick={() => {
                                            if (!showPreview && preview.length == 0) dispatch(getPreview(clientId, dataType, blankExport))
                                            setShowPreview(!showPreview)
                                        }}
                                        style={{ marginBottom: "20px" }}>
                                        {!showPreview ? "Show" : "Hide"} Preview
                                    </Button>
                                    <Button disabled={loading} icon={<DownloadOutlined />} onClick={() => dispatch(getTemplate(clientId, dataType, blankExport))} style={{ marginBottom: "20px" }}>
                                        Generate Template File
                                    </Button>
                                </div>
                            </Col>
                        </Row>

                        {showPreview && (
                            <>
                                <hr />
                                <div className="badged-header">
                                    <h2>Preview Values</h2>
                                </div>
                                <br />
                                {getPreviewTable()}
                            </>
                        )}

                        <hr />

                        <Row gutter={24}>
                            <Col span={24}>
                                <Upload maxCount={1} accept="csv" beforeUpload={fileSelect} onRemove={fileRemove}>
                                    <Button icon={<FileAddOutlined />}>Select File</Button>
                                </Upload>
                            </Col>
                        </Row>

                        <br />

                        <Row gutter={24}>
                            <Col span={24}>
                                <Button
                                    disabled={!file}
                                    type="primary"
                                    onClick={() => {
                                        openNotification()
                                        dispatch(processImport(clientId, dataType, file))
                                    }}
                                    loading={loading}>
                                    Submit
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    )
}